(() => {
    class StickyCTA {
        constructor(root) {
            this.root = root;
            this.btn = root.querySelector('[data-rb-atc]');
            this.qty = root.querySelector('[data-rb-qty] .quantity__input');
            this.priceEl = root.querySelector('[data-rb-price]');
            this.compareEl = root.querySelector('[data-rb-compare]');

            // --- Find the main product-info node (Dawn puts data on it) ---
            this.productInfo =
                root.closest('product-info') ||
                document.querySelector(`product-info[data-product-id="${root.dataset.productId || ''}"]`) ||
                document.querySelector('product-info');

            // Section id exists on <product-info data-section="...">
            this.sectionId = this.productInfo?.dataset?.section || '';

            // Resolve the real add-to-cart form (robust)
            this.form = this._resolveForm();

            // Debug
            console.log({
                productId: this.productInfo?.dataset?.productId || null,
                sectionId_from_dom: this.sectionId || null,
                resolvedFormId: this.form?.id || null
            });

            if (!this.form || !this.btn || !this.qty) return;

            this.hiddenVariantInput = this.form.querySelector('input[name="id"]');
            this.mainQtyInput = this.form.querySelector('input[name="quantity"]') || null;

            this._bind();
            this._observeBuyBox();
            this._observeVariant();
            this._syncQtyFromMain();
        }

        // Try the canonical id first, then fallbacks inside product-info
        _resolveForm() {
            let form = null;

            // A) Canonical Dawn pattern if we have sectionId
            if (this.sectionId) {
                const guessId = `product-form-${this.sectionId}__main`;
                form = document.getElementById(guessId);
            }

            // B) Any cart/add form under the same product-info
            if (!form && this.productInfo) {
                form = this.productInfo.querySelector('form[action*="/cart/add"][id^="product-form-"]');
            }

            // C) Absolute fallback: first cart/add form on page
            if (!form) {
                form = document.querySelector('form[action*="/cart/add"][id^="product-form-"]');
            }

            return form;
        }


        // _bind() {
        //     // Mirror qty -> main form (live as user types)
        //     this.qty.addEventListener('input', () => {
        //         const v = Math.max(1, parseInt(this.qty.value || '1', 10));
        //         this.qty.value = v;
        //         if (this.mainQtyInput) this.mainQtyInput.value = v;
        //     });

        //     // ATC via the REAL Dawn submit button
        //     this.btn.addEventListener('click', () => {
        //         if (this.btn.disabled) return;

        //         // 1) lock in the quantity for submission
        //         const submitQty = Math.max(1, parseInt(this.qty.value || '1', 10));
        //         if (this.mainQtyInput) this.mainQtyInput.value = submitQty;

        //         // 2) trigger Dawn's submit so all theme/app logic runs
        //         const realSubmit = this.form.querySelector('[type="submit"]');
        //         if (realSubmit) {
        //             realSubmit.click();
        //         } else if (this.form.requestSubmit) {
        //             this.form.requestSubmit();
        //         } else {
        //             this.form.submit();
        //         }

        //         // 2.5) scroll back to the buy box
        //         this._scrollToBuyBox();

        //         // 3) reset both qty inputs to 1 *after* the submit kicked off
        //         setTimeout(() => {
        //             this.qty.value = 1;
        //             if (this.mainQtyInput) this.mainQtyInput.value = 1;

        //             // fire events so Dawn’s quantity UI updates
        //             this.qty.dispatchEvent(new Event('input', { bubbles: true }));
        //             this.qty.dispatchEvent(new Event('change', { bubbles: true }));
        //             if (this.mainQtyInput) {
        //                 this.mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        //                 this.mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        //             }
        //         }, 10);
        //     });
        // }

        _bind() {
  // Mirror qty -> main form (only matters on desktop where qty is visible)
  if (this.qty) {
    this.qty.addEventListener('input', () => {
      const v = Math.max(1, parseInt(this.qty.value || '1', 10));
      this.qty.value = v;
      if (this.mainQtyInput) this.mainQtyInput.value = v;
    });
  }

  // ATC via the REAL Dawn submit button
  this.btn.addEventListener('click', () => {
    if (this.btn.disabled) return;

    // Mobile = “ADD” only -> always submit 1
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const submitQty = isMobile
      ? 1
      : Math.max(1, parseInt((this.qty && this.qty.value) || '1', 10));

    if (this.mainQtyInput) this.mainQtyInput.value = submitQty;

    // Trigger Dawn’s real submit so all theme/app logic runs
    const realSubmit = this.form.querySelector('[type="submit"]');
    if (realSubmit) {
      realSubmit.click();
    } else if (this.form.requestSubmit) {
      this.form.requestSubmit();
    } else {
      this.form.submit();
    }

    // Scroll back to buy box
    this._scrollToBuyBox();

    // Reset both qty inputs to 1 after submit kicks off (desktop UX nicety)
    setTimeout(() => {
      if (this.qty) {
        this.qty.value = 1;
        this.qty.dispatchEvent(new Event('input', { bubbles: true }));
        this.qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (this.mainQtyInput) {
        this.mainQtyInput.value = 1;
        this.mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 10);
  });
}


        _scrollToBuyBox() {
            const target =
                this.form.closest('.product__info-container') ||
                this.productInfo ||
                this.form;

            if (!target) return;

            // don’t scroll if it’s already in view
            if (this._isInViewport(target, 16)) return;

            // try to account for Dawn’s sticky header
            const header =
                document.querySelector('sticky-header') ||
                document.getElementById('shopify-section-header') ||
                document.querySelector('header.header');

            const headerH = header ? header.getBoundingClientRect().height : 0;

            // smooth scroll with a tiny offset
            const y = target.getBoundingClientRect().top + window.scrollY - headerH - 12;
            window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        }

        _isInViewport(el, pad = 0) {
            const r = el.getBoundingClientRect();
            const h = (document.documentElement.clientHeight || window.innerHeight);
            return r.top >= 0 + pad && r.bottom <= h - pad;
        }




        _observeBuyBox() {
            // Show sticky bar only when the buy box is out of view
            const target =
                this.form.closest('.product__info-container') ||
                this.productInfo ||
                this.form;

            if (!('IntersectionObserver' in window) || !target) {
                this._show(); // fallback
                return;
            }

            const io = new IntersectionObserver((entries) => {
                const e = entries[0];
                if (!e) return;
                e.isIntersecting ? this._hide() : this._show();
            }, { rootMargin: '0px 0px -20% 0px', threshold: 0 });

            io.observe(target);
        }

        _observeVariant() {
            const updateFromDOM = () => {
                // Read selected variant JSON Dawn drops into the DOM
                const json = this.productInfo?.querySelector('script[data-selected-variant]')?.textContent?.trim();
                if (!json) return;
                try {
                    const v = JSON.parse(json);
                    if (v && typeof v.price === 'number') {
                        this._setPrice(v.price, v.compare_at_price);
                        this._toggleAvailability(!!v.available);
                    }
                } catch (_) { }
            };

            // changes from option radios/selects
            this.form.addEventListener('change', (ev) => {
                if (ev.target?.name === 'id' || ev.target?.closest('[data-product-url]')) {
                    updateFromDOM();
                }
            });

            // mutation backup (Dawn often swaps inputs)
            const mo = new MutationObserver(updateFromDOM);
            mo.observe(this.form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });

            // init
            updateFromDOM();
        }

        _syncQtyFromMain() {
            if (!this.mainQtyInput) return;
            const sync = () => { this.qty.value = this.mainQtyInput.value || 1; };
            this.mainQtyInput.addEventListener('input', sync);
            sync();
        }

        _formatMoney(cents) {
            if (window.Shopify?.formatMoney) {
                try { return window.Shopify.formatMoney(cents); } catch { }
            }
            return `$${(cents / 100).toFixed(2)}`;
        }

        _setPrice(priceCents, compareCents) {
            if (this.priceEl) this.priceEl.textContent = this._formatMoney(priceCents);
            if (!this.compareEl) return;
            if (compareCents && compareCents > priceCents) {
                this.compareEl.textContent = this._formatMoney(compareCents);
                this.compareEl.style.display = '';
            } else {
                this.compareEl.style.display = 'none';
            }
        }

        _toggleAvailability(isAvailable) {
            this.btn.disabled = !isAvailable;
            this.root.classList.toggle('is-soldout', !isAvailable);
            this.btn.textContent = isAvailable
                ? (window.themeStrings?.addToCart || 'Add')
                : (window.themeStrings?.soldOut || 'Sold out');
        }

        _show() {
            if (this.root.hasAttribute('hidden')) {
                this.root.removeAttribute('hidden');
                document.documentElement.classList.add('product-sticky-cta--active');
            }
        }
        _hide() {
            if (!this.root.hasAttribute('hidden')) {
                this.root.setAttribute('hidden', '');
                document.documentElement.classList.remove('product-sticky-cta--active');
            }
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        const el = document.getElementById('product-sticky-cta');
        if (el) new StickyCTA(el);
    });
})();
